import { useQuery } from '@tanstack/react-query';
import { getIntegrationStatus } from '../../Authentication/api';
import { classifyWhatsAppStatus } from '../utils/messagingChannels';

export const WHATSAPP_REQUEST_TIMEOUT_MS = 20000;

export function useWhatsAppConnection(companyId) {
  const query = useQuery({
    queryKey: ['whatsapp-connection', companyId],
    enabled: !!companyId,
    retry: false,
    queryFn: ({ signal }) =>
      getIntegrationStatus(
        { companyId, integrationSlug: 'whatsapp' },
        { signal, timeout: WHATSAPP_REQUEST_TIMEOUT_MS },
      ),
  });

  let phase = 'checking';
  if (!companyId) phase = 'error';
  else if (query.isError) {
    phase = query.error?.response?.status === 404 ? 'disconnected' : 'error';
  } else if (query.isSuccess) phase = classifyWhatsAppStatus(query.data);

  return {
    phase,
    refetch: query.refetch,
  };
}
